import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MainMapService } from '../../../shared/service/main-map.service';
import { EsriExpand } from '../../../config/esri.module';
import { WidgetNotifyService } from '../../../shared/service/widget-notify.service';
import { ConfigService } from '../../../config/config.service';
import { GeoPortaleConfig } from '../../../config/model/geoportale-config.model';
import { TranslateService } from '@ngx-translate/core';
import { BaseWidget } from '../base-widget/base-widget';

@Component({
    selector: 'geo-portale',
    templateUrl: './geo-portale.component.html',
    styleUrls: ['geo-portale.component.scss'],
    standalone: false
})
export class GeoPortaleComponent extends BaseWidget implements OnInit, AfterViewInit {
  // Reference to DOM element of this component
  @ViewChild('geoPortaleComponentRef', { static: true }) geoPortaleComponentRef: ElementRef;
  public geoPortale: GeoPortaleConfig;
  public widgetToolTip: string;

  constructor(
    public mainMapService: MainMapService,
    public widgetNotifyService: WidgetNotifyService,
    private _translate: TranslateService,
    private _configService: ConfigService,
  ) {
    super(mainMapService, widgetNotifyService);
    this.geoPortale = this._configService.geoPortaleConfig;
  }

  ngOnInit() {
    // this.version = this._configService.appConfig.version;
    // get the map view
    const mapView: __esri.MapView = this.mainMapService.mapView;

    // translate tooltip
    this._translate.get('WIDGET.GEO_PORTALE.TOOLTIP').subscribe(msg => {
      this.widgetToolTip = msg;
    });

    // create an expand instance
    const expandProperties: __esri.ExpandProperties = {
      view: mapView,
      id: 'GeoPortaleComponent',
      content: this.geoPortaleComponentRef.nativeElement,
      expandIcon: 'globe',
      collapseTooltip: this.widgetToolTip,
      expandTooltip: this.widgetToolTip,
    };
    this.expandWidget = new EsriExpand(expandProperties);

    // add widget to the main map
    mapView.ui.add(this.expandWidget, 'top-right');
    this.initWidgetListeners();
  }

  ngAfterViewInit() {
    // super.initDraggable(this.geoPortaleComponentRef);
  }
}
